function handleCheckoutClick(productId, code) {
  navigator.clipboard.writeText(code).then(() => {
    const lockSpan = document.getElementById(`lock-${productId}`);
    const textSpan = document.getElementById(`text-${productId}`);
    
    // Change Text
    textSpan.innerText = 'Apply at checkout!';
    
    // Switch to Unlocked Padlock SVG
    lockSpan.innerHTML = `
      <svg width="12" height="12" viewBox="0 0 24 24" fill="#D4AF37">
        <path d="M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h2c0-1.66 1.34-3 3-3s3 1.34 3 3v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2z"/>
      </svg>
    `;

    // Revert after 3 seconds
    setTimeout(() => {
      textSpan.innerText = 'Unlock Savings!';
      lockSpan.innerHTML = `
        <svg width="12" height="12" viewBox="0 0 24 24" fill="#D4AF37">
          <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
        </svg>
      `;
    }, 3000);
  });
}